const rowItemOpacity = (index: number) => ({
  visible: {
    opacity: 1,
    transition: {
      delay: 1 + index,
      duration: 0.2,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
});

const connectorStaggerChildren = {
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.4,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: "afterChildren",
    },
  },
};

const dividerMoveX = {
  visible: {
    x: 0,
    transition: {
      duration: 1,
    },
  },
  hidden: {
    x: -140,
  },
};

const ballMoveX = {
  visible: {
    x: 140,
    transition: {
      duration: 2.8,
    },
  },
  hidden: {
    x: -140,
  },
};

export { rowItemOpacity, connectorStaggerChildren, dividerMoveX, ballMoveX };
